import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Bell } from "lucide-react";
import { api } from "@/lib/api";

export default function AlertsBadge() {
  const [count, setCount] = useState(0);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/alerts/unread");
      setCount(Number(data?.count || 0));
    } catch {/* silent */}
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000); // poll every 30s
    return () => clearInterval(t);
  }, [load]);

  return (
    <Link to="/alerts" className="relative inline-flex items-center justify-center h-9 w-9 rounded-md hover:bg-secondary" data-testid="alerts-bell">
      <Bell className="h-4 w-4" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 h-4 min-w-[16px] px-1 rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold grid place-items-center" data-testid="alerts-badge-count">
          {count > 99 ? "99+" : count}
        </span>
      )}
    </Link>
  );
}
